export default __webpack_public_path__ + "static/media/Group-6-Yono@2x.33165222.png";